export default "__VITE_ASSET__B0J4K6_m__"